import React, { memo, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Pagination } from 'swiper';
import 'swiper/css/pagination';
import SampleCollectionCtaCard from '../../baseUiV3/moduleCTA/SampleCollectionCtaCard';
import { Modal } from 'react-bootstrap';
import FormQuestions from '../../FormQuestions';
import axiosInstance from '../../../Store/helper/axiosInstance';
import { toast } from 'react-toastify';
import FormQuestionModal from '../../FormQuestionModal';
SwiperCore.use([Pagination]);
const SampleCollectionSwiper = ({ sampleCtaData = [] }) => {
  const [show, setShow] = useState(false);
  const onHide = () => setShow(false);
  const showModal = () => setShow(true);
  const [form, setForm] = useState([]);

  const ctaInfo = useRef({
    cta_id: 0,
    cta_type: ''
  });
  const onSampleCtaClick = (data) => {
    console.log('clicked sample cta data:', data);
    setForm(data.form);
    ctaInfo.current.cta_id = data.id;
    ctaInfo.current.cta_type = data.cta_type;
    showModal();
  };

  const submitClick = async (userInput) => {
    console.log('user has clicked submit button');
    if (form.some((_q) => _q.is_mandatory == 1 && !userInput[_q.field_name])) {
      toast.error('Please fill all mandatory fields');
      return;
    }
    let response = await axiosInstance.post('cta/cta_submitted_forms', {
      cta_id: ctaInfo.current.cta_id,
      cta_type: ctaInfo.current.cta_type,
      submitted_form_json: userInput
    });
    console.log('response:', response);
    if (response.status == 200) {
      toast.success('Your Response submitted successfully');
      onHide();
    }
  };
  return (
    <>
      <Swiper
        slidesPerView={1}
        pagination={{ clickable: true }}
        spaceBetween={14}
        className={
          'w-100 clr_v3_swiper bg-white rounded-3 overflow-hidden ' +
          (sampleCtaData?.length > 1 ? 'pb-5' : '')
        }
      >
        {sampleCtaData?.map((key, ind) => (
          <SwiperSlide key={ind} className="">
            <div className="w-100" key={key.id}>
              <SampleCollectionCtaCard
                ctaId={key.id}
                buttonText={key.button_text}
                image={key.image}
                onClick={() => {
                  onSampleCtaClick(key);
                }}
                subTitle={key.sub_header}
                title={key.title}
                description={key.description}
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {form.length > 0 && (
        <FormQuestionModal show={show} onHide={onHide} submitClick={submitClick} form={form} />
      )}
    </>
  );
};

export default memo(SampleCollectionSwiper);
